<template>
  <div class="v-popover">
    <el-popover
      v-bind="$attrs"
    >
      <span slot="reference" class="see-table-btn">
        <slot name="popover-btn"></slot>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'VPopover',
  props: {
    width: {
      type: [String, Number],
      default: 450
    },
    trigger: {
      type: String,
      default: 'click'
    },
    placement: {
      type: String,
      default: 'right'
    }
  },
  methods: {
    open() {
      this.$emit('handle-show')
    },
    close() {
      this.$emit('handle-hide')
    }
  }
}
</script>

<style lang="scss">
  .v-popover {
    .see-table-btn {
      color: #0068B6;
      text-decoration: underline;
      cursor: pointer;
    }
  }
</style>
